import * as z from 'zod';

export const dateRangeSchema = z
  .object({
    start: z.date().optional(),
    end: z.date().optional(),
  })
  .refine(
    (data) => {
      // If either start or end is defined, both must be defined
      return (!data.start && !data.end) || (data.start && data.end);
    },
    {
      message: 'Both start and end dates must be defined if one is defined.',
    }
  );
